export enum RequirementTypes {
  SOCIAL_SECURITY_CARD = 118,
  DRIVER_LICENSE = 48,
}
